import { parseISO } from 'date-fns';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import { getDepartureDate, getOrigin, ShipmentWithRelations } from '@/models/shipment';
import { formatDate } from '@/utils/date';
import useViewPort from '@/utils/useViewport';

import { useDisplayedShipmentCountry } from '../hooks/useDisplayedShipmentCountry';

export const ShipmentOrigin = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  const { originCountry } = useDisplayedShipmentCountry({ shipment });
  const { isMobile } = useViewPort();

  const origin = getOrigin(shipment);

  if (!origin) {
    return '-';
  }

  const date =
    getDepartureDate(shipment) ?? (shipment.pickupDate ? parseISO(shipment.pickupDate) : null);

  return (
    <Stack gap={isMobile ? undefined : '0.125rem'}>
      <Stack
        row={isMobile}
        alignItems={isMobile ? 'center' : 'flex-start'}
        gap={isMobile ? '0.25rem' : '0'}
      >
        <InlineText weight="medium">{origin.name}</InlineText>
        {isMobile && (
          <InlineText size="200" color="secondary">
            •
          </InlineText>
        )}
        <InlineText size="200" color="secondary">
          {[shipment.originAddress?.city, shipment.originAddress?.state, originCountry?.name]
            .filter((el) => !!el)
            .join(', ')}
        </InlineText>
      </Stack>
      {date && (
        <InlineText size="200" color="secondary">
          {formatDate(date, { dateStyle: 'short' })}
        </InlineText>
      )}
    </Stack>
  );
};
